export default "__VITE_ASSET__Bcon8llF__"